<template>
  <div>
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="onPullRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="getList"
      >
        <div class="my-earning-record">
          <EarningCard
            v-for="(item, index) in list"
            :key="index"
            :value="item || {}"
          />

          <div
            v-if="!list.length"
            class="my-blank"
          >
            <Blank text="暂无收益" />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 悬浮按钮 -->
    <FabBtn
      text="收益规则"
      @click="() => $refs.refRulePopup.openPopup()"
    />
    <!-- 规则弹窗 -->
    <RulePopup ref="refRulePopup" />
  </div>
</template>

<script>
import EarningCard from './components/EarningCard.vue';
import FabBtn from './components/FabBtn.vue';
import RulePopup from './components/RulePopup.vue';
import { chargeCouponMyEarn } from '@/common/api';
import Blank from './components/Blank.vue';
import tokenMixin from './mixins/tokenMixin.js';

class CreateQuery {
  pageSize = 10;
  pageNum = 1;
}

export default {
  name: 'MyEarning',
  components: {
    EarningCard,
    FabBtn,
    RulePopup,
    Blank
  },
  mixins: [tokenMixin],
  data() {
    return {
      list: [],
      loading: false,
      finished: true,
      showPullRefreshLoading: false,
      query: new CreateQuery()
    };
  },
  mounted() {
    this.onPullRefresh();
  },
  methods: {
    onPullRefresh() {
      this.query = new CreateQuery();
      this.list = [];
      this.showPullRefreshLoading = false;
      this.finished = true;
      this.$nextTick(() => {
        this.getList();
      });
    },
    getList() {
      this.loading = true;
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      chargeCouponMyEarn(this.query)
        .then((res) => {
          if (res) {
            this.list = this.list.concat(res.list || []);
            ++this.query.pageNum;
            if (!res.total || this.list.length >= res.total) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          } else {
            this.finished = true;
          }
          this.$toast.clear();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-earning-record {
  background : #F7F7F7;
  min-height : 100vh;
  padding : 16px 32px;
  color : #383838;
  box-sizing : border-box;
  overflow-y : auto;

  .my-blank {
    transform : translateY(30vh);
  }
}
.bottom {
  padding-top : 12px;
  color : #C8C8C8;
  padding-bottom : 32px;
  text-align : center;
}

</style>
